import bankBookResultPageDefinition from './bankBookResultPageDefinition';
import cardStatementResultPageDefinition from './cardStatementResultPageDefinition';
import {
  dualHorizontalReceiptResultPageDefinition,
  dualVerticalReceiptResultPageDefinition,
} from './dualReceiptResultPageDefinition';
import furusatoTaxResultPageDefinition from './furusatoTaxResultPageDefinition';
import generalMultiTableResultPageDefinition from './generalMultiTableResultPageDefinition';
import generalTableResultPageDefinition from './generalTableResultPageDefinition';
import invoiceResultPageDefinition from './invoiceResultPageDefinition';
import medicalBillResultPageDefinition from './medicalBillResultPageDefinition';
import multiReceiptResultPageDefinition from './multiReceiptResultPageDefinition';
import ocrErrorResultPageDefinition from './ocrErrorResultPageDefinition.';
import paymentRecordPageDefinition from './paymentRecordPageDefinition';
import receiptResultPageDefinition from './receiptResultPageDefinition';
import { DocumentEntities, DocumentEntityOfType, OcrResultPageDefinition } from './types';
import withholdingSlipResultPageDefinition from './withholdingSlipResultPageDefinition';

const ocrResultPageDefinitions: {
  [type in DocumentEntities['type']]: OcrResultPageDefinition<DocumentEntityOfType<type>>;
} = {
  furusato_tax: furusatoTaxResultPageDefinition,
  medical_bill: medicalBillResultPageDefinition,
  bankbook: bankBookResultPageDefinition,
  card_statement: cardStatementResultPageDefinition,
  withholding_slip: withholdingSlipResultPageDefinition,
  receipt: receiptResultPageDefinition,
  payment_record: paymentRecordPageDefinition,
  dual_horizontal_receipt: dualHorizontalReceiptResultPageDefinition,
  dual_vertical_receipt: dualVerticalReceiptResultPageDefinition,
  multi_receipt: multiReceiptResultPageDefinition,
  general_table: generalTableResultPageDefinition,
  general_multi_table: generalMultiTableResultPageDefinition,
  invoice: invoiceResultPageDefinition,
  ocr_error: ocrErrorResultPageDefinition,
};
export default ocrResultPageDefinitions;
